import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
  body: string;
};

export const DashboardAlert: FC<Props> = ({ title, body }) => {
  const { t } = useTranslation();
  return (
    <div className="w-full">
      <div className="sm:col-span-6">
        <div className="rounded bg-sand-10 p-3 sm:p-4 border border-l-sand-400 border-l-4">
          <div className="flex items-start">
            <div className="bg-sand-400 rounded p-1.5 sm:p-2 flex shrink-0">
              <ExclamationTriangleIcon
                aria-hidden="true"
                className="size-5 sm:size-6 text-white"
              />
            </div>
            <div className="ml-3">
              <h3 className="text-base sm:text-lg font-medium text-slate-500">
                {title}
              </h3>
              <div className="mt-2 text-sm sm:text-md text-slate-500">
                <div
                  dangerouslySetInnerHTML={{
                    __html: t(body, {
                      interpolation: {
                        escapeValue: false,
                      },
                    }),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
